import React from 'react';
import styled from 'styled-components';
import { useGetBackground, useGetBackgroundSafe } from '../../types/utils';
import { CpWidgetDidiverProps } from './cp-widget-divider';

const Parent = styled.div<{ widgetColor; nextWidgetColor; height }>`
  .custom-shape-divider-bottom-1715763292 {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0;
    transform: rotate(180deg);
    background: ${({ widgetColor }) => widgetColor ?? 'white'} !important;
  }

  .custom-shape-divider-bottom-1715763292 svg {
    position: relative;
    display: block;
    width: calc(100% + 1.3px);
    height: ${({ height }) => height ?? '74px'};
    transform: rotateY(180deg);
  }

  .custom-shape-divider-bottom-1715763292 .shape-fill {
    fill: ${({ nextWidgetColor }) => nextWidgetColor ?? 'white'} !important;
  }

  .custom-shape-divider-bottom-1715763412 {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0;
    transform: rotate(180deg);
    background: ${({ widgetColor }) => widgetColor ?? 'white'} !important;
  }

  .custom-shape-divider-bottom-1715763412 svg {
    position: relative;
    display: block;
    width: calc(100% + 1.3px);
    height: ${({ height }) => height ?? '74px'};
  }

  .custom-shape-divider-bottom-1715763412 .shape-fill {
    fill: ${({ nextWidgetColor }) => nextWidgetColor ?? 'white'} !important;
  }
`;

export const CpRectWithShorterRightVertex: React.FC<CpWidgetDidiverProps> = ({
  widget,
  nextWidget,
}) => {
  const widgetColor = useGetBackground(widget);
  const nextWidgetColor = useGetBackgroundSafe(nextWidget);

  const isDividerEnabled =
    widget?.widgetDefinition?.styles?.isDividerEnabled ?? false;
  const isFlipped = widget?.widgetDefinition?.styles?.isFlip ?? false;
  const height =
    `${widget?.widgetDefinition?.styles?.height ?? 50}px` ?? '50px';

  return (
    isDividerEnabled && (
      <>
        {isFlipped ? (
          <Parent
            widgetColor={widgetColor}
            nextWidgetColor={nextWidgetColor}
            height={height}
          >
            <div className="custom-shape-divider-bottom-1715763412">
              <svg
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1200 120"
                preserveAspectRatio="none"
              >
                <path
                  d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
                  className="shape-fill"
                />
              </svg>
            </div>
          </Parent>
        ) : (
          <Parent
            widgetColor={widgetColor}
            nextWidgetColor={nextWidgetColor}
            height={height}
          >
            <div className="custom-shape-divider-bottom-1715763292">
              <svg
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1200 120"
                preserveAspectRatio="none"
              >
                <path
                  d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
                  className="shape-fill"
                />
              </svg>
            </div>
          </Parent>
        )}
      </>
    )
  );
};
